var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.owners_association)?_c('contact',{attrs:{"owners_association":_vm.owners_association,"messages_enabled":_vm.messages_enabled}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }